import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import pl from "./locales/pl/translation.json"
import en from "./locales/en/translation.json"
import de from "./locales/de/translation.json"
import es from "./locales/es/translation.json"
import sk from "./locales/sk/translation.json"
import ua from "./locales/ua/translation.json"
// kolejne języki później

i18n
  .use(initReactI18next)
  .init({
    resources: {
      pl: { translation: pl },
      en: { translation: en },
      de: { translation: de },
      es: { translation: es },
      sk: { translation: sk },
      ua: { translation: ua },
    },
    lng: (typeof window !== "undefined" && localStorage.getItem("appLanguage")) || "pl",
    fallbackLng: "pl",
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
